const u = up.util;
up.EventListenerGroup = class EventListenerGroup extends up.Record {
    keys() {
        return [
            'elements',
            'eventTypes',
            'selector',
            'callback',
            'guard',
            'baseLayer',
            'passive',
            'once',
            'capture',
            'beforeBoot',
        ];
    }
    bind() {
        const cleaner = u.cleaner();
        this._eachListenerAttributes(function (attrs) {
            const listener = new up.EventListener(attrs);
            listener.bind();
            return cleaner(listener.unbind.bind(listener));
        });
        return cleaner.clean;
    }
    _eachListenerAttributes(fn) {
        for (let element of this.elements) {
            for (let eventType of this.eventTypes) {
                fn(this._listenerAttributes(element, eventType));
            }
        }
    }
    _listenerAttributes(element, eventType) {
        return Object.assign(Object.assign({}, this.attributes()), { element, eventType });
    }
    unbind() {
        this._eachListenerAttributes(function (attrs) {
            let listener = up.EventListener.fromElement(attrs);
            if (listener) {
                listener.unbind();
            }
        });
    }
    static fromBindArgs(args, overrides) {
        args = u.copy(args);
        const callback = args.pop();
        let elements;
        if (args[0].addEventListener) {
            elements = [args.shift()];
        }
        else if (u.isJQuery(args[0]) || (u.isList(args[0]) && args[0][0].addEventListener)) {
            elements = args.shift();
        }
        else {
            elements = [document];
        }
        let eventTypes = u.getSimpleTokens(args.shift());
        let fixTypes = up.migrate.fixEventTypes;
        if (fixTypes) {
            eventTypes = fixTypes(eventTypes);
        }
        const options = u.extractOptions(args);
        const selector = args[0];
        const attributes = Object.assign(Object.assign({ elements, eventTypes, selector, callback }, options), overrides);
        return new (this)(attributes);
    }
};
